/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} QueuedInputs */



/**
* | output |
* | --- |
* | "Queued" |
*
* @param {QueuedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const queued = /** @type {((inputs?: QueuedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<QueuedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En file d’attente")
	if (locale === "de") return /** @type {LocalizedString} */ ("In der Warteschlange")
	if (locale === "it") return /** @type {LocalizedString} */ ("In coda")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В очереди")
	if (locale === "es") return /** @type {LocalizedString} */ ("En cola")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已排队")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キューに登録")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कतारबद्ध")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Em fila")
	return /** @type {LocalizedString} */ ("Queued")
});